import classNames from "classnames"

import React, { useState } from "react"
import { Card, CardBody, Col, Collapse, Row } from "reactstrap"
import { useTranslation } from "react-i18next"

export const products = [
  {
    id: "ID-145875",
    name: "bottle 500 ml",
    performance: "20% of campaign sales",
    price: "QAR 20,00",
    soldUnit: 70,
    totalUnit: 200,
    img: "https://t4.ftcdn.net/jpg/08/51/86/79/360_F_851867929_KLcb1aBSarlkw6PbDhmrtiszOcF6yD3x.jpg",
  },
  {
    id: "ID-145876",
    name: "bottle 100 ml",
    performance: "10% of campaign sales",
    price: "QAR 20,00",
    soldUnit: 120,
    totalUnit: 200,
    img: "https://t3.ftcdn.net/jpg/07/86/76/06/360_F_786760607_IwcScz3k7Efj42i1S7mnewhWQXrhAa0o.jpg",
  },
  {
    id: "ID-145877",
    name: "bottle 200 ml",
    performance: "70% of campaign sales",
    price: "QAR 20,00",
    soldUnit: 20,
    totalUnit: 200,
    img: "https://img.freepik.com/free-photo/plastic-bottle-water_93675-132408.jpg",
  },
]

const OfferPerformance = () => {
  const { t } = useTranslation()
  const [openAccordion, setOpenAccordion] = useState(true)
  return (
    <Card className="border bg-white shadow-sm">
      <div className="accordion" id="accordion">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button
              className={classNames("accordion-button", "fw-medium", {
                collapsed: !openAccordion,
              })}
              type="button"
              onClick={() => setOpenAccordion(!openAccordion)}
              style={{ cursor: "pointer" }}
            >
              {t("offers_offerPerformance")}
            </button>
          </h2>
          <Collapse isOpen={openAccordion} className="accordion-collapse">
            <div className="accordion-body">
              <Row>
                {products.map(product => (
                  <Col xl="4" sm="6" key={product.id}>
                    <Card className="text-center rounded-3 overflow-hidden shadow-md pb-3">
                      <CardBody className="p-0">
                        <div
                          className="position-relative overflow-hidden"
                          style={{ maxHeight: "200px" }}
                        >
                          <img
                            src={product.img}
                            className="card-img-top"
                            alt="Product"
                          />
                        </div>

                        <div className="card-body p-2 px-3">
                          <div className="d-flex justify-content-between align-items-start p-2">
                            <small className="text-semi-dark fw-semibold size-12">
                              {product.name}
                            </small>
                          </div>
                          <div className="text-start p-2">
                            <span className="text-semi-dark fw-semibold size-14">
                              {product.price}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center p-2">
                            <span className="fw-bold">
                              {t("offers_performance")}
                            </span>
                            {product.performance && (
                              <span className="badge bg-primary-30 text-primary fw-semibold me-1 px-2 py-1 font-size-10">
                                {product.performance}
                              </span>
                            )}
                          </div>
                        </div>

                        <div
                          className="progress bg-primary-20 rounded-full mx-4 my-1"
                          style={{ height: "12px" }}
                        >
                          <div
                            className="progress-bar bg-primary"
                            role="progressbar"
                            style={{
                              width: `${Math.min(
                                ((product.totalUnit - product.soldUnit) /
                                  product.totalUnit) *
                                  100,
                                100
                              )}%`,
                            }}
                          >
                            {/* {product.soldUnit} / {product.totalUnit} */}
                          </div>
                        </div>
                        <div className="text-start text-primary text-14 mx-4">
                          {product.soldUnit} {t("offers_soldUnits")}
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          </Collapse>
        </div>
      </div>
    </Card>
  )
}

export default OfferPerformance
